module.exports = __webpack_public_path__ + "static/img/testRBg.36f5c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testRBg.png
// module id = 3oKf
// module chunks = 1